import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    ProductGradeHorizontalModule,
} from '@app/shared/product/product-grade/product-grade-horizontal/product-grade-horizontal.module';
import {
    ProductGradeNumberModule,
} from '@app/shared/product/product-grade/product-grade-number/product-grade-number.module';
import { ProductGradeModule } from '@app/shared/product/product-grade/product-grade.module';
import { RobotComponent } from '@app/shared/ui/robot/robot.component';

@NgModule({
    declarations: [
        RobotComponent,
    ],
    imports: [
        CommonModule,
        ProductGradeModule,
        ProductGradeHorizontalModule,
        ProductGradeNumberModule,
    ],
    exports: [
        RobotComponent,
    ],
})
export class RobotModule {
}
